import { render, staticRenderFns } from "./VehicleChoiceButton.vue?vue&type=template&id=06ecf131&"
import script from "./VehicleChoiceButton.vue?vue&type=script&lang=js&"
export * from "./VehicleChoiceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports